import { Entity } from '@zdr-tools/zdr-entities';
/** What "Save dates" found wrong before sending anything. */
export var TripDatesProblem;
(function (TripDatesProblem) {
    TripDatesProblem["NONE"] = "NONE";
    /** The start date's text is not a date the field could read. */
    TripDatesProblem["UNREADABLE_START"] = "UNREADABLE_START";
    /** The end date's text is not a date the field could read. */
    TripDatesProblem["UNREADABLE_END"] = "UNREADABLE_END";
    /** One date is set and the other is empty (both or neither). */
    TripDatesProblem["ONE_DATE_MISSING"] = "ONE_DATE_MISSING";
    /** The end date is before the start date. */
    TripDatesProblem["END_BEFORE_START"] = "END_BEFORE_START";
})(TripDatesProblem || (TripDatesProblem = {}));
/** The trip page's "Trip dates" dialog: its save state (a `TripFieldEdit`) and what "Save dates" found wrong. */
export class TripDatesEdit extends Entity {
    fieldEdit;
    problem;
    problemRevision;
    constructor(fieldEdit) {
        super('trip-dates-edit');
        this.fieldEdit = fieldEdit;
        this.problem = this.createPropEventBroker('problem', TripDatesProblem.NONE);
        this.problemRevision = this.createPropEventBroker('problemRevision', 0);
        this.addSubEntity(fieldEdit);
    }
    getEntityName() {
        return 'TripDatesEdit';
    }
    getFieldEdit() {
        return this.fieldEdit;
    }
    open() {
        this.clearProblem();
        this.fieldEdit.open();
    }
    close() {
        this.clearProblem();
        this.fieldEdit.close();
    }
    markProblem(problem) {
        this.problem.set(problem);
        this.problemRevision.set(this.problemRevision.get() + 1);
    }
    clearProblem() {
        this.problem.set(TripDatesProblem.NONE);
    }
}
//# sourceMappingURL=TripDatesEdit.js.map